import { Box, Grid, Typography } from '@mui/material';
import { colors } from '../styles/fontStyles';
import { styled } from '@mui/material/styles';
import OrderCheckoutStepperWrapper from './OrderCheckoutStepperWrapper';
import OrderCheckoutProductImage from './OrderCheckoutProductImage';
import { useThemeContext } from '../contexts/BaseThemeContextProvider';

const GridPaymentContainer = styled(Grid)(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    alignItems: 'left',
    flexDirection: 'column',
    textAlign: 'left',
  },
}));

type CheckoutPaymentMethodContainerProps = {
  children: React.ReactNode;
  handleBack: () => void;
  activeStep: number;
};

export default function CheckoutPaymentMethodContainer({
  handleBack,
  activeStep,
  children,
}: CheckoutPaymentMethodContainerProps) {
  const { theme } = useThemeContext();
  return (
    <>
      <OrderCheckoutStepperWrapper handleBack={handleBack} activeStep={activeStep} />
      <GridPaymentContainer container spacing={2}>
        <OrderCheckoutProductImage />
        <Grid item xs={12} sm={12} md={7}>
          <Typography gutterBottom sx={{ typography: { sm: 'h5', md: 'h3' }, display: { xs: 'none', md: 'flex' } }}>
            Buy home PFAS test
          </Typography>
          <Box
            sx={{ display: 'flex', justifyContent: { xs: 'flex-start', sm: 'flex-start', md: 'flex-start' }, width: '100%' }}
          >
            <Typography
              variant="h5"
              sx={{
                mb: 3,
                background: theme.custom.orderPFAS.subheader.background,
                color: theme.custom.orderPFAS.subheader.color,
                width: 'fit-content',
              }}
              gutterBottom
            >
              Checkout
            </Typography>
          </Box>
          {children}
        </Grid>
      </GridPaymentContainer>
    </>
  );
}
